import history from 'utils/history';
import { adminInitialState } from './admin';
import { appInitialState } from './app';
import { authInitialState } from './auth';
import { ApplicationRootState } from './types';

const initialState: ApplicationRootState = {
    app: appInitialState,
    auth: authInitialState,
    admin: adminInitialState,
    router: history as any,
};

export default initialState;
